import type { ComponentProps } from 'react';
import { FormattedMessage } from 'gatsby-plugin-react-intl';

import type { MessageKeyOrString } from '~localization';

export interface FormattedMessageWithFallbackProps extends Omit<ComponentProps<typeof FormattedMessage>, 'id'> {
    message: MessageKeyOrString;
}

export const FormattedMessageWithFallback = ({ message, ...props }: FormattedMessageWithFallbackProps) => {
    // @ts-expect-error
    return <FormattedMessage id={message} defaultMessage={message} {...props} />;
};
